import { styled, Button, ButtonProps } from "@mui/material";

export const Styled = {
    Container: styled("div")`
        height: 150px;
        display: flex;
        align-items: center;
        justify-content: space-around;
        flex-direction: column;
        transition: border-color 0.5s ease, color 0.5s ease;

        &:hover {
            border-color: ${props => props.theme.palette.secondary.light};
        }
    `,
    FileInput: styled("input")`
        clip: rect(0 0 0 0);
        clip-path: inset(50%);
        height: 1;
        overflow: hidden;
        position: absolute;
        bottom: 0;
        left: 0;
        white-space: nowrap;
        width: 1;
    `,
    Placeholder: styled(Button)<ButtonProps>`
        border-radius: 50%;
        height: 150px;
        width: 150px;
        transition: 0.4s ease-in-out;

        & .MuiTypography-root {
            color: white;
            font-size: 60px;
        }

        &:hover {
            box-shadow: 0 0 8px 2px rgba(9, 52, 66, 0.7);
        }
    `,
    ChangeButton: styled(Button)<ButtonProps>`
        padding: 0px;
        color: white;
    `,
    Image: styled("img")`
        height: 150px;
        width: 150px;
        border-radius: 50%;
    `,
    IconOverlay: styled("div")`
        background: none;
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        border-radius: 50%;
        display: flex;
        justify-content: center;
        align-items: center;
        background-color: rgba(0, 0, 0, 0.2);
        transition: opacity 0.5s ease-in-out;
    `,
};
